import { render, staticRenderFns } from "./ViewsBody.vue?vue&type=template&id=18e6b24b&"
import script from "./ViewsBody.vue?vue&type=script&lang=js&"
export * from "./ViewsBody.vue?vue&type=script&lang=js&"
import style0 from "./ViewsBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports